import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { appearingAnimation } from "../../shared/styles";
import { PreviewAspectRatio, type Scale } from "../models";
import { calculateDimensions } from "../utils/calculateDimensions";

export const LensPreviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const LensPreviewElement = styled.div<{
    scale?: Scale;
    cursor?: string;
    aspectRatio?: PreviewAspectRatio;
    disabled?: boolean;
}>`
    cursor: ${({ disabled, cursor = "pointer" }) => (disabled ? "cursor" : cursor)};

    display: flex;
    align-items: center;
    justify-content: center;

    width: ${({ scale, aspectRatio = PreviewAspectRatio.nineSixteen }) =>
        `${calculateDimensions(aspectRatio, scale).width}px`};
    height: ${({ scale, aspectRatio = PreviewAspectRatio.nineSixteen }) =>
        `${calculateDimensions(aspectRatio, scale).height}px`};

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Colors.Gray.V300};
    text-align: center;

    background: ${Colors.Gray.V50};
    border: 1px dashed ${Colors.Gray.V250};
    border-radius: 6px;

    transition: all 200ms;

    &:hover,
    &:focus {
        ${({ disabled }) => !disabled && `background: rgba(0, 0, 0, 10%); border: 2px solid ${Colors.Yellow.V200};`};
    }
`;

export const LensPreviewTextContainer = styled.span`
    width: 107px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Colors.Gray.V300};
    text-align: center;
`;

export const IconContainer = styled.div`
    position: relative;
    z-index: 1;

    display: flex;
    justify-content: center;

    margin-top: -32px;
`;

export const IconElement = styled.img<{ cursor?: string }>`
    cursor: ${({ cursor = "pointer" }) => cursor};

    width: 46px;
    height: 46px;

    background: ${Colors.Gray.V50};
    border: 1px solid ${Colors.Black.V100};
    border-radius: 60px;
`;

export const AddPreviewButton = styled.img`
    cursor: pointer;

    position: absolute;
    right: 8px;

    width: 25px;
    height: 25px;

    animation: ${appearingAnimation} 200ms ease;
`;

export const previewsModalCss = css`
    .ant-modal-body {
        position: relative; /* positioning context for the previews' own absolute children */

        /* A flex column with a floor rather than a fixed height: the button row is the last item in
           flow, so content taller than the floor — a validation message under the two panels, or one
           more specification line — pushes the row down instead of rendering behind it. It used to
           be pinned with position: absolute, which clipped exactly that message in half. */
        display: flex;
        flex-direction: column;
        min-height: 450px;
    }
`;
